import { Component, OnInit, EventEmitter, Output} from '@angular/core';
import { faCalendarWeek, faArrowRight, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { NgbDate, NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
import { GlobalHolderService } from 'src/app/global-holder.service';



@Component({
    selector: 'odl-week-selector',
    templateUrl: './week-selector.component.html',
    styleUrls: ['./week-selector.component.scss'],
})

export class WeekSelectorComponent implements OnInit {

    @Output() changed = new EventEmitter<[Date, Date]>();

    faCalendarWeek = faCalendarWeek;
    faLeft = faArrowLeft;
    faRight = faArrowRight;

    selected_week: [Date, Date] = [null, null];

    constructor(
        private calendar: NgbCalendar,
        private globals: GlobalHolderService,
    ) { }

    ngOnInit() {
        const selected_week = this.globals.get('selected_week');
        if ( !selected_week ) {
            const today = moment();
            let fdow = today.clone().weekday(1).hour(0).minute(0).second(0);
            let ldow = today.clone().weekday(7).hour(23).minute(59).second(59);
            this.selected_week = [fdow.toDate(), ldow.toDate()];
        } else {
            this.selected_week = selected_week;
        }

        this.changed.emit(this.selected_week);

    }

    onSelect(date: NgbDate) {
        let selectedDay = moment(date.year + '-' + date.month + '-' + date.day, 'YYYY-M-D');
        let fdow = selectedDay.clone().weekday(1).hour(0);
        let ldow = selectedDay.clone().weekday(7).hour(23).minute(59).second(59);
        this.selected_week = [fdow.toDate(), ldow.toDate()];

        this.globals.set('selected_week', this.selected_week);
        this.changed.emit(this.selected_week);
    }

    inSelectedRange(day: NgbDate) {
        let momentDay = moment(day.year + '-' + day.month + '-' + day.day, 'YYYY-M-D');
        let fdow = moment(this.selected_week[0]);
        let ldow = moment(this.selected_week[1]);
        return momentDay.isSame(fdow, 'day') || momentDay.isSame(ldow, 'day') || (momentDay.isAfter(fdow) && momentDay.isBefore(ldow));
    }

    gotoNextWeek() {
        const nextweek = moment(this.selected_week[0]).add('1', 'week');
        
        let fdow = nextweek.clone().weekday(1).hour(0).minute(0).second(0);
        let ldow = nextweek.clone().weekday(7).hour(23).minute(59).second(59);
        this.selected_week = [fdow.toDate(), ldow.toDate()];

        this.globals.set('selected_week', this.selected_week);
        this.changed.emit(this.selected_week);
    }

    gotoPrevWeek() {
        const prevweek = moment(this.selected_week[0]).subtract('1', 'week');
        
        let fdow = prevweek.clone().weekday(1).hour(0).minute(0).second(0);
        let ldow = prevweek.clone().weekday(7).hour(23).minute(59).second(59);
        this.selected_week = [fdow.toDate(), ldow.toDate()];
        
        this.globals.set('selected_week', this.selected_week);
        this.changed.emit(this.selected_week);
    }
}